export default __webpack_public_path__ + "static/media/left-btn.20460347.svg";